import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";
import { AxiosResponse } from "axios";
import ComuneModel from "./models/ComuneModel";
import EffectUtility from "utilities/EffectUtility";
import TipoDocumentoModel from "./models/TipoDocumentoModel";
import CittadinanzaModel from "./models/CittadinanzaModel";
import NazioneModel from "./models/NazioneModel";
import TipoIndirizzoModel from "./models/TipoIndirizzoModel";
import AmministrazioneModel from "./models/AmministrazioneModel";
import TipoRichiedenteModel from "stores/tipo-richiedente/models/TipoRichiedenteModel";
import ConsensoPrivacyModel from "stores/consenso-privacy/models/ConsensoPrivacyModel";
import FondoModel from "./models/FondoModel";
import CqsOnlineTipoCodiceFiscaleModel from "stores/cqsonline/models/CqsOnlineTipoCodiceFiscaleModel";
import ModalitaErogazioneModel from "./models/ModalitaErogazioneModel";
import TipologiaPensioneModel from "./models/TipologiaPensioneModel";
import CategoriaAmministrativaModel from "./models/CategoriaAmministrativaModel";
import TipologiaImpegnoModel from "./models/TipologiaImpegnoModel";
import QuoteSocietaModel from "./models/QuoteSocietaModel";
import ImportoConIntermediariModel from "./models/ImportoConIntermediariModel";
import IstitutoFinanziarioModel from "./models/IstitutoFinanziarioModel";

export default class LookUpEffect {
    public static async requestConsensoPrivacy(): Promise<ConsensoPrivacyModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.consensoPrivacy;
        return EffectUtility.getToModel<ConsensoPrivacyModel[]>(ConsensoPrivacyModel, endpoint);
    }

    public static async requestTipoRichiedentes(): Promise<TipoRichiedenteModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.tipoRichiedente;
        return EffectUtility.getToModel<TipoRichiedenteModel[]>(TipoRichiedenteModel, endpoint);
    }

    public static async requestComuneNascita(
        comune: string,
        codice: string
    ): Promise<ComuneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.comuniNascita;
        return EffectUtility.getToModel<ComuneModel[]>(ComuneModel, endpoint, { comune, codice });
    }

    public static async requestComuneResidenza(
        comune: string,
        codice: string
    ): Promise<ComuneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.comuniResidenza;
        return EffectUtility.getToModel<ComuneModel[]>(ComuneModel, endpoint, { comune, codice });
    }

    public static async requestTipoDocumento(): Promise<TipoDocumentoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.tipoDocumento;
        return EffectUtility.getToModel<TipoDocumentoModel[]>(TipoDocumentoModel, endpoint);
    }

    public static async requestCittadinanza(): Promise<CittadinanzaModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.cittadinanza;
        return EffectUtility.getToModel<CittadinanzaModel[]>(CittadinanzaModel, endpoint);
    }

    public static async requestNazione(): Promise<NazioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.nazione;
        return EffectUtility.getToModel<NazioneModel[]>(NazioneModel, endpoint);
    }

    public static async requestTipoIndirizzo(): Promise<TipoIndirizzoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.tipoIndirizzo;
        return EffectUtility.getToModel<TipoIndirizzoModel[]>(TipoIndirizzoModel, endpoint);
    }

    public static async requestAmministrazione(
        codiceTipoRichiedente: string
    ): Promise<AmministrazioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.amministrazione;
        return EffectUtility.getToModel<AmministrazioneModel[]>(AmministrazioneModel, endpoint, {
            codiceTipoRichiedente,
        });
    }

    public static async requestFondo(): Promise<FondoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.fondo;
        return EffectUtility.getToModel<FondoModel[]>(FondoModel, endpoint);
    }

    // #region CQSonline
    public static async requestTipoDocumentoCQSonline(): Promise<TipoDocumentoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.tipoDocumentoCQSonline;
        return EffectUtility.getToModel<TipoDocumentoModel[]>(TipoDocumentoModel, endpoint);
    }

    public static async requestTipoCodiceFiscaleCQSonline(): Promise<
        CqsOnlineTipoCodiceFiscaleModel[] | HttpErrorResponseModel
    > {
        const endpoint: string = environment.api.getTipoCodiceFiscaleCQSonline;
        return EffectUtility.getToModel<CqsOnlineTipoCodiceFiscaleModel[]>(CqsOnlineTipoCodiceFiscaleModel, endpoint);
    }

    public static async requestModalitaErogazione(): Promise<ModalitaErogazioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getModalitaErogazione;
        return EffectUtility.getToModel<ModalitaErogazioneModel[]>(ModalitaErogazioneModel, endpoint);
    }

    public static async requestTipologiaPensione(): Promise<TipologiaPensioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getTipoPensione;
        return EffectUtility.getToModel<TipologiaPensioneModel[]>(TipologiaPensioneModel, endpoint);
    }

    public static async requestCategoriaAmministrativa(
        codiceTipoRichiedente: string
    ): Promise<CategoriaAmministrativaModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getCategoriaAmministrativa;
        return EffectUtility.getToModel<CategoriaAmministrativaModel[]>(CategoriaAmministrativaModel, endpoint, {
            codiceTipoRichiedente,
        });
    }

    public static async requestTipologiaImpegno(
        codiceTipoRichiedente: string
    ): Promise<TipologiaImpegnoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getTipologiaImpegni;
        return EffectUtility.getToModel<TipologiaImpegnoModel[]>(TipologiaImpegnoModel, endpoint, {
            codiceTipoRichiedente,
        });
    }

    public static async requestVociAmministrazioneConvenzione(
        codiceTipoRichiedente: string
    ): Promise<AmministrazioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.vociAmministrazioneConvenzione;
        return EffectUtility.getToModel<AmministrazioneModel[]>(AmministrazioneModel, endpoint, {
            codiceTipoRichiedente,
        });
    }

    public static async requestQuoteSocietarie(): Promise<QuoteSocietaModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getQuoteSocietarie;
        return EffectUtility.getToModel<QuoteSocietaModel[]>(QuoteSocietaModel, endpoint);
    }

    public static async requestImportiConIntermediari(): Promise<
        ImportoConIntermediariModel[] | HttpErrorResponseModel
    > {
        const endpoint: string = environment.api.getImportiIntermediari;
        return EffectUtility.getToModel<ImportoConIntermediariModel[]>(ImportoConIntermediariModel, endpoint);
    }

    public static async requestIstitutiFinanziari(): Promise<IstitutoFinanziarioModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getIstitutiFinanziari;
        return EffectUtility.getToModel<IstitutoFinanziarioModel[]>(IstitutoFinanziarioModel, endpoint);
    }

    public static async requestConsesiPrivacyUtente(): Promise<ConsensoPrivacyModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getconsensoPrivacyUtente;
        return EffectUtility.getToModel<ConsensoPrivacyModel[]>(ConsensoPrivacyModel, endpoint);
    }

    // #endregion CQSonline

    //campo non necessario
    /*  public static async requestQualifica(): Promise<QualificaModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.qualifica;
        return EffectUtility.getToModel<QualificaModel[]>(QualificaModel, endpoint);
    }
    */
    public static async requestError(): Promise<any | HttpErrorResponseModel> {
        const endpoint: string = environment.api.errorExample;
        const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(endpoint);
        if (response instanceof HttpErrorResponseModel) {
            return response;
        }
        return response.data;
    }
}
